import Connections from '../../connections';
import {
  action, observable,
} from 'mobx';
import {
  createEventCategory, getEventCategory, getEventCategoryById, updateEventCategory,
} from '../../axios/eventsRequests';
import {
  IEventCategory,
} from '../storeInterfaces/eventsCategoryInterface';
import { RequestStatus } from 'mobx-store';

export class EventCategoryStore {
  @observable eventCategoryList: IEventCategory[] = [];

  @observable selectedEventCategory = {

  };


  @observable loading = false;

  @observable getEventsCategoryRequestStatus: RequestStatus = RequestStatus.IDLE;

  @action
  public async getEventCategory(): Promise<void> {
    try {
      this.loading = true;
      this.getEventsCategoryRequestStatus = RequestStatus.LOADING;
      const response = await Connections.wadiDeglaAxios.httpGet(getEventCategory);
      this.eventCategoryList = response.data;
      this.getEventsCategoryRequestStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.getEventsCategoryRequestStatus = RequestStatus.FAILED;
      console.log(error);
      return Promise.reject(error);
    } finally {
      this.loading = false;
    }
  }

  @action
  public async filterEventCategory(query: string): Promise<void> {
    try {
      this.loading = true;
      const config = {
        params: {
          query,
        },
      };
      const response = await Connections.wadiDeglaAxios.httpGet(getEventCategory, config);
      this.eventCategoryList = response.data;
    } catch (error) {
      console.log(error);
      return Promise.reject(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async getEventCategoryById(id: number): Promise<void> {
    try {
      this.loading = true;
      const response = await Connections.wadiDeglaAxios.httpGet(getEventCategoryById(id));
      this.selectedEventCategory = response.data;
    } catch (error) {
      console.log(error);
      return Promise.reject(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async createEventCategory(newEventCategory: IEventCategory): Promise<number> {
    try {
      const response = await Connections.wadiDeglaAxios.httpPost(createEventCategory, newEventCategory);
      return response.data.eventCategoryId;
    } catch (error) {
      console.log(error);
      return Promise.reject(error);
    }
  }

  @action.bound
  public async updateEventCategory(updatedEventCategory: any, eventCategoryId: number): Promise<void> {
    try {
      await Connections.wadiDeglaAxios.httpPut(updateEventCategory(eventCategoryId), updatedEventCategory);
    } catch (error) {
      console.log(error);
      return Promise.reject(error);
    }
  }
}
